import ApiDocument from "../Services/api/controller/document";

export default async () => {
  const body = {
    empowerment: true,
    factura: true,
    act: true
  }
  await ApiDocument.synchronizeSeveralDocumentsFromTax(body);
}